import * as React from 'react';
import { Skills } from '../../../shared/components';

interface Skill {
  id: string | number;
  name: string;
  category: string;
  color: string;
}

interface JobSkillsProps {
  skills: Skill[];
  job: any;
}

/**
 * JobSkills Component
 * 
 * Wrapper around the shared Skills component specifically for job listings.
 * Displays job position type, benefits, and required skills with proper formatting.
 */
export default function JobSkills({ skills, job }: JobSkillsProps) {
  return (
    <Skills
      skills={skills}
      type="job"
      data={job}
      showPositionTypes={true}
    />
  );
}
